import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "download-forecast-modal__main-content main-content" }
const _hoisted_2 = { class: "main-content__select-period select-period" }
const _hoisted_3 = { class: "select-period__label" }
const _hoisted_4 = { class: "select-period__content-container" }
const _hoisted_5 = { class: "select-period__content" }
const _hoisted_6 = { class: "select-period__picker-container" }
const _hoisted_7 = {
  class: "select-period__picker-label",
  for: "start-month"
}
const _hoisted_8 = { class: "select-period__picker-container" }
const _hoisted_9 = {
  class: "select-period__picker-label",
  for: "end-month"
}
const _hoisted_10 = {
  key: 0,
  class: "select-period__attention"
}

import { i18n } from '@/i18n';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import { storeToRefs } from 'pinia';
import { AllBusinessesForSupplierForecastStore } from '@/supplierForecastModule/pages/useAllBusinessesForSupplierForecastStore';
import { computed } from 'vue';
import SelectInput from '@/corePagesModule/SelectInput';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadForecastModal',
  props: {
    store: {},
    indexOfSelectInput: { default: 1 }
  },
  setup(__props: any) {

const props = __props;

//変数
const t = i18n.t;
const locale = computed(() => i18n.locale);

const { state } = storeToRefs(props.store);

const modalState = computed({
  /**
   * getter
   */
  get: () => {
    return state.value.downloadForecastModalState.modalState;
  },
  /**
   * setter
   * @param value - value
   */
  set: (value) => {
    // 変数初期化
    state.value.downloadForecastModalState.startMonthPickerState = false;
    state.value.downloadForecastModalState.endSelectInputState = false;
    state.value.downloadForecastModalState.startInvalidMessageState = false;
    state.value.isOpenSelectInputType = undefined;
    state.value.downloadForecastModalState.modalState = value;
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": modalState.value,
    "back-button-label": _unref(t)('もどる'),
    "next-button-label": _unref(t)('ダウンロード'),
    "modal-width": 500,
    "is-disabled-next-button": _ctx.store.isDisabledDownloadButton,
    "is-disabled-scroll": true,
    onOnBack: _cache[6] || (_cache[6] = ($event: any) => (modalState.value = false)),
    onOnNext: _ctx.store.onApplyDownload
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('仕入先内示ダウンロード')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('期間の選択')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)('開始月')), 1),
                _createVNode(MonthPicker, {
                  class: "select-period__calendar-picker",
                  "model-value": _unref(state).downloadForecastModalState.period.start,
                  "prop-format": _unref(t)('MonthPickerFormat'),
                  placeholder: '2024/10',
                  locale: locale.value,
                  "use-teleport": false,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.onSelectedStartPeriod($event))),
                  onOpen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.store.toggleStartMonthPicker(true))),
                  onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.store.toggleStartMonthPicker(false)))
                }, null, 8, ["model-value", "prop-format", "locale"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)('終了月')), 1),
                _createVNode(_unref(SelectInput), {
                  class: "select-period__end-month",
                  index: _ctx.indexOfSelectInput,
                  "model-value": _ctx.store.getEndPeriodLabel,
                  placeholder: '',
                  label: '',
                  "filter-type": 'DISPLAY_YEAR_MONTH',
                  "prop-options": _ctx.store.getYearMonthListForEndPeriod,
                  "is-open-prop": _unref(state).downloadForecastModalState.endSelectInputState,
                  "onClick:selectInput": _cache[3] || (_cache[3] = () => _ctx.store.toggleEndSelectInput(true)),
                  onClose: _cache[4] || (_cache[4] = () => _ctx.store.toggleEndSelectInput(false)),
                  "onUpdate:valueWithIndex": _cache[5] || (_cache[5] = (_, index) => _ctx.store.onSelectedEndPeriod(index))
                }, null, 8, ["index", "model-value", "prop-options", "is-open-prop"])
              ])
            ]),
            (_unref(state).downloadForecastModalState.startInvalidMessageState)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)('開始月の無効メッセージ')), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button", "onOnNext"]))
}
}

})